import cx from "classnames"
import React from "react"

import type { HeadingAlignType, HeadingAsType, HeadingFontsType, HeadingTextColorsType } from "./types"

import styles from "./index.module.css"
import { HEADING_ALIGN, HEADING_FONTS, HEADING_AS, HEADING_TEXT_COLORS } from "./types"

export type HeadingProps<T extends HeadingAsType> = {
  as?: T
  fontFamily?: HeadingFontsType
  color?: HeadingTextColorsType
  align?: HeadingAlignType
} & Pick<React.ComponentPropsWithoutRef<T>, "children" | "id">

export const Heading = <T extends HeadingAsType = "h2">({
  children,
  as,
  fontFamily = "brand",
  color = "highlighted",
  align = "left",
  ...htmlProps
}: HeadingProps<T>): React.JSX.Element => {
  const Component = as ?? "h2"
  const combinedClasses = cx(
    styles[HEADING_FONTS[fontFamily]],
    styles[HEADING_AS[Component as HeadingAsType]],
    styles[HEADING_ALIGN[align]],
    color && styles[HEADING_TEXT_COLORS[color]],
  )

  return (
    <Component className={combinedClasses} {...htmlProps}>
      {children}
    </Component>
  )
}
